import React from 'react';
import { observer } from 'mobx-react-lite';
import { colors } from '@insurancemenu/imenu-components-lib';
import { MessageStyled, TableCellStyled, TableCellWithErrorStyled, TableCellWithWarningStyled } from './styles';
import { CENSUS_TABLE_CELL_TEST_ID } from '../../../constants';

interface Props {
  value: string;
  errorMessage?: string;
  warningMessage?: string;
}

const CensusTableCellComponent: React.FC<Props> = observer(({ value, errorMessage, warningMessage }) => {
  if (errorMessage) {
    return (
      <TableCellWithErrorStyled data-test-id={CENSUS_TABLE_CELL_TEST_ID}>
        <MessageStyled $color={colors.red[600]}>{errorMessage}</MessageStyled>
        {value}
      </TableCellWithErrorStyled>
    );
  }
  if (warningMessage) {
    return (
      <TableCellWithWarningStyled data-test-id={CENSUS_TABLE_CELL_TEST_ID}>
        <MessageStyled $color={colors.orange[800]}>{warningMessage}</MessageStyled>
        {value}
      </TableCellWithWarningStyled>
    );
  }
  return <TableCellStyled data-test-id={CENSUS_TABLE_CELL_TEST_ID}>{value}</TableCellStyled>;
});

export default CensusTableCellComponent;
